import { Singleton } from "util";
import BaseService from "./base.service";
import { ApiResourceBuilder } from "core/builder";

@Singleton
class DiscountService extends BaseService {
  async fetch(companyUuid, { filters, order, pagination }) {
    const url = `/v1/discounts`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      filters,
      order,
      pagination
    });
    return await this.get(resourceRoute);
  }

  async fetchByUuid(_, uuid) {
    return await this.get(`/v1/discounts/${uuid}`);
  }

  async updateDiscount(uuid, params) {
    return await this.update(`/v1/discounts/${uuid}`, params);
  }

  async create(params) {
    if (params.end_date === "") {
      delete params.end_date;
    }
    return await this.post(`/v1/discounts`, params);
  }
}

export default DiscountService;



// WEBPACK FOOTER //
// ./src/core/service/discount.service.js